
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Translation } from '../Configure';
import TranslationEditorLocale from './TranslationEditorLocale';
import LocalizationStore from '../../../../stores/LocalizationStore';

@Component({
  components: {
    TranslationEditorLocale,
  },
})
export default class TranslationEditor extends Vue {
  @Prop({ required: true })
  translation!: Translation;
  @Prop({ required: true })
  editInherited!: boolean;
  @Prop({ required: true })
  isNew!: boolean;

  readonly store = new LocalizationStore();
}
